/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import { ContentState, EditorState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import React from 'react';
// import { Button, Modal, ModalProps } from 'react-bootstrap';
import { Editor } from 'react-draft-wysiwyg';
import { useTranslation } from 'react-i18next';
import { IAppNotification } from 'store/app-notifications/types';
import Modal, { IModalProps } from 'components/UI_kit_3/Modal/Modal';
import Button from 'components/UI_kit_3/Button/Button';
import { ReactComponent as NotificationIcon } from 'assets/icons_3/notification.svg';
import styles from './AppNotificationModal.module.scss';

interface IAppNotificationModalProps extends IModalProps {
  notification: IAppNotification | null
  closable?: boolean
}

const AppNotificationModal: React.FC<IAppNotificationModalProps> = ({
  notification, closable, onHide, ...props
}) => {
  const [t] = useTranslation();
  const [editorState, setEditorState] = React.useState<EditorState | undefined>(undefined);

  React.useEffect(() => {
    if (notification?.notificationText) {
      const contentBlock = htmlToDraft(notification.notificationText.replace(/\\n/g, '<br>'));
      if (contentBlock) {
        setEditorState(
          EditorState.createWithContent(
            ContentState.createFromBlockArray(contentBlock.contentBlocks),
          ),
        );
      }
    }
  }, [notification]);
  return (
    <Modal {...props} onHide={onHide}>
      <Modal.Header closeButton>
        <div className={styles.headerInner}>
          <span className={styles.icon}><NotificationIcon /></span>
          <span className="fornt-md-semibold">{notification?.subjectText}</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Editor
          wrapperClassName={styles.appNotificationModal__wrapper}
          editorState={editorState}
          toolbarHidden
          readOnly
          editorClassName={styles.appNotificationModal__text}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => onHide && onHide()}
          qa-element="notification-close"
          className={styles.close}
        >
          {t('common.close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AppNotificationModal;
